import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const baseDraftLeaseRoute = `${BASE_PATH_API}/draftLeases`;
const baseDraftLeaseV3Route = `${BASE_PATH_API}/v3/draftLeases`;

const actions = {
    getAll: {
        method: 'GET',
        url: baseDraftLeaseRoute,
        params: {
            '$count': true
        }
    },
    getAllV3: {
        method: 'GET',
        url: baseDraftLeaseV3Route
    },
    getDraftLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId`
    },
    updateDraftLeaseComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/comment`
    },
    updateDraftLeaseTerms: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/terms`
    },
    updateDraftLeaseStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/status`
    },
    setDraftLeaseFinancials: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/financials`
    },
    getDraftLeaseFinancials: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/financials`
    },
    saveFile: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/files`
    },
    save: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases`
    },
    createELeaseAgreement: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements`
    },
    getELeaseAgreements: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements`,
        isArray: true
    },
    getELeaseAgreement: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/current`
    },
    getLatestELeaseAgreement: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/:eLeaseAgreementId/refresh`
    },
    cancelELeaseAgreement: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/:eLeaseAgreementId`
    },
    getFiles: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/files`,
        isArray: true
    },
    deleteFile: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/agreements/files/:entityTypeId/:fileId`
    },
    overlappingDraftLeases: {
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/overlappingLeases`,
        isArray: true
    },
    draftLeaseActivate: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/activate`
    },
    retryActivation: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/activate/retry`
    },
    getLeaseByDraftLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/lease`
    },
    saveDraftLeaseCosigners: {
        method: 'POST',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/cosigners`,
        isArray: true
    },
    getCosignersForLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/cosigners`
    },
    getDraftLeaseDisplay: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/display`
    },
    setDraftLeaseLeasingAgent: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/leasingAgent`
    },
    deleteDraftLease: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId`
    },
    cancelLeaseRenewal: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/renewals/:renewalOfferId`
    },
    queryLeasingAgents: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/leasingAgents`,
        isArray: true
    },
    getOverlappingDraftLeasesWithEsignatureActionEnablement: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/draftLeases/:draftLeaseId/overlappingLeases`
    },
    getExistingTenantsAndApprovedApplicantsByDraftLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/potentialTenants`,
        isArray: true
    },
    getPotentialTenantsForUnitId: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/unit/:unitId/potentialTenants`,
        isArray: true
    },
    getPotentialApplicants: {
        method: 'GET',
        url: `${BASE_PATH_API}/draftLeases/potentialApplicants`
    },
    updateLeasingComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/draftLeases/:draftLeaseId/leasingComment`
    },
};

export function DraftLeaseApi() {
    return createActions(actions);
}
